
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliates",
      function () {
        return require("private-next-pages/affiliates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliates"])
      });
    }
  